import { cn } from "@/lib/utils";

const GeneralSummaryCard = ({ children, className, icon, ...props }) => {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-lg border bg-white px-3 py-6 text-center shadow-sm",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

GeneralSummaryCard.Content = ({
  children,
  className,
  icon: Icon,
  iconColor = "text-blue-500",
  ...props
}) => {
  return (
    <div className={cn("flex items-center gap-3", className)} {...props}>
      {Icon && (
        <div className={cn("rounded-full bg-blue-50 p-1.5", iconColor)}>
          <Icon className="h-5 w-5" />
        </div>
      )}
      <div className="flex flex-col items-start text-left">{children}</div>
    </div>
  );
};

export default GeneralSummaryCard;
